import { render, staticRenderFns } from "./picGrid.vue?vue&type=template&id=2a6a0879&scoped=true&"
import script from "./picGrid.vue?vue&type=script&lang=js&"
export * from "./picGrid.vue?vue&type=script&lang=js&"
import style0 from "./picGrid.vue?vue&type=style&index=0&id=2a6a0879&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6a0879",
  null
  
)

export default component.exports